import { Tag } from "components"

export default function Stock({ available, reserved, ...props }){
    return(
    <>
        <Tag label="Estoque" w="45px" children={available} borderRadius="8px 0 0 8px" />
        <Tag label="Reservado" w="45px" children={reserved} colorScheme="orange" borderRadius="0 8px 8px 0" />
    </>
    )
}